import React, { createContext, useContext } from 'react';
import type { AppContextValue } from './types';

/**
 * App-weiter Context. In V2 getypt; Aufteilung in Auth/Toast/Feature-Contexts folgt in Phase 2.
 */
export const AppContext = createContext<AppContextValue | null>(null);

export function useApp(): AppContextValue {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error('useApp must be used within AppContext.Provider');
  return ctx;
}
